module.exports = __webpack_public_path__ + "static/media/coffee-1.7e9f4271.jpg";